import { breakpoints } from 'styles/mq'
import { useParallax } from 'components/parallax/useParallax'
import BooksSrc from './images/books.png'
import BooksLaptopSrc from './images/books-with-laptop.png'
import { BookContainer, BookImg } from './styled'

export const ParallaxBook = () => {
  const { ref, translateY } = useParallax({ fromTo: ['-30rem', '30rem'] })

  return (
    <BookContainer ref={ref} style={{ translateY }}>
      <picture>
        <source srcSet={BooksLaptopSrc} media={breakpoints.parallaxOff} />
        <BookImg src={BooksSrc} alt="" aria-hidden />
      </picture>
    </BookContainer>
  )
}
